import {defineMessages} from 'react-intl';

const messages = defineMessages({
  feedbackPromptLabel: {
    id: 'docsApp.clui.feedbackPromptLabel',
    description: 'Label shown when the user first opens the feedback form.',
    defaultMessage: 'Feedback on this experience:',
  },
  optionalResponsePlaceholder: {
    id: 'docsApp.clui.optionalResponseLabel',
    description:
      'Placeholder shown in the textarea for an optional freeform response.',
    defaultMessage: 'Optional response...',
  },
  feedbackTitle: {
    id: 'docsApp.clui.feedbackTitle',
    description: 'Title of the dialog which displays csat form.',
    defaultMessage: 'Feedback on your developer experience',
  },
  feedbackClose: {
    id: 'docsApp.clui.feedbackClose',
    description: 'Label for the action to close the csat form',
    defaultMessage: 'Close',
  },
  submitLabel: {
    id: 'docsApp.clui.submitLabel',
    description: 'Label text on the action to submit the feedback form.',
    defaultMessage: 'Submit',
  },
  cancelLabel: {
    id: 'docsApp.clui.cancelLabel',
    description: 'Label text on the action to cancel the feedback form.',
    defaultMessage: 'Cancel',
  },
  feedbackToolTip: {
    id: 'docsApp.clui.feedbackToolTip',
    description: 'Label for the feedback tool tip',
    defaultMessage: 'Feedback',
  },
});

export default messages;
